module.exports = __webpack_public_path__ + "img/notebook_pranc_sw2.b82ba91c.svg";